import createComponentRegistry from "../ComponentRegistry/registry";
import Attribute from "./components/Attribute";
import Chart from "./components/Chart";
import Highchart from "./components/Highchart";
import ImageEditor from "./components/ImageEditor/ImageEditor";
import PlaceHolder from "./components/Placeholder";
import PreviewImage from "./components/PreviewImage";
import PreviewText from "./components/PreviewText";
import RichText from "./components/RichText";

export const template = createComponentRegistry(PlaceHolder, {
  text: PreviewText,
  image: PreviewImage,
  chart: PreviewImage,
  Highchart: PreviewImage,
  metadata: PreviewText,
});

export const thumbNails = createComponentRegistry(PlaceHolder, {
  text: PreviewText,
  image: PreviewImage,
  chart: PreviewImage,
  Highchart: PreviewImage,
  metadata: PreviewText,
});

// make sure that they are all lowercase. so that it matches with editor state when needed
export const fullScreen = createComponentRegistry(PlaceHolder, {
  text: RichText,
  image: ImageEditor,
  Highchart,
  chart: Chart,
  metadata: Attribute,
});
